// ===== CACHE & CONSTANTS =====
const SEL = {
  colorBtn: '.color-dropdown-btn',
  colorMenu: '.color-dropdown-menu',
  colorOption: '.color-option',
  sizeBtn: '.size-dropdown-btn',
  sizeMenu: '.size-dropdown-menu',
  sizeOption: '.size-option',
  sizeWrapper: '.size-dropdown-wrapper',
  colorWrapper: '.color-dropdown-wrapper',
  recoItem: '.sticky-reco-item',
  hProduct: '.horizontal-product',
  variantInput: '.variant-id-input',
  price: 'price-list',
  image: '.sticky-reco-item__image, .horizontal-product__image',
  submitBtn: 'form[is="product-form"] button[type="submit"]',
};

function setAddToCartState(container, isAvailable) {
  const wrap = container?.querySelector('.reco-stock-state');
  if (!wrap) return;
  wrap.classList.toggle('is-available', isAvailable);
  wrap.classList.toggle('is-sold-out', !isAvailable);
}

const ALL_MENUS = `${SEL.colorMenu}, ${SEL.sizeMenu}`;
const closeAllMenus = () => {
  document.querySelectorAll(ALL_MENUS).forEach(m => m.style.display = 'none');
  document.querySelectorAll(`${SEL.colorBtn}, ${SEL.sizeBtn}`).forEach(btn => btn.classList.remove('open'));
};
const getContainer = el => el.closest(SEL.recoItem) || el.closest(SEL.hProduct);

// ===== CORE FUNCTIONS =====
function updateProductColor(wrapper, colorHex, colorLabel) {
  const btn = wrapper.querySelector(SEL.colorBtn);
  const menu = wrapper.querySelector(SEL.colorMenu);
  const option = menu.querySelector(`[data-color="${colorHex}"]`);
  if (!option) return;

  const container = getContainer(wrapper);
  if (!container) return;

  // Update button UI
  btn.querySelector('.color-dot').style.background = colorHex;
  btn.querySelector('.color-label').textContent = colorLabel;
  menu.style.display = 'none';
  btn.classList.remove('open');

  const image = container.querySelector(SEL.image);
  const variantId = option.getAttribute('data-variant-id');
  const productHandle = btn.getAttribute('product-handle');

  if (image) image.style.opacity = '0.5';

  // Yield au navigateur pour peindre le feedback visuel avant de faire le fetch
  setTimeout(() => {
    fetch(`${location.origin}/products/${productHandle}?variant=${variantId}&section_id=variant_details`)
      .then(r => r.text())
      .then(html => {
        const newImg = new DOMParser().parseFromString(html, 'text/html').querySelector('.variant-image img');
        if (!newImg || !image) return;

        const img = new Image();
        img.onload = () => {
          image.src = newImg.src;
          image.srcset = newImg.srcset || '';
          image.style.opacity = '1';
          updateSizeAvailability(wrapper, colorLabel);
        };
        img.onerror = () => { image.style.opacity = '1'; };
        img.src = newImg.src;
      })
      .catch(() => { if (image) image.style.opacity = '1'; });
  }, 0);
}

function updateSizeAvailability(wrapper, colorLabel) {
  const container = getContainer(wrapper);
  const sizeWrapper = container?.querySelector(SEL.sizeWrapper);
  if (!sizeWrapper) return;

  let variants;
  try { variants = JSON.parse(sizeWrapper.getAttribute('data-variants')); }
  catch { return; }

  let firstAvailable = null;

  sizeWrapper.querySelectorAll(SEL.sizeOption).forEach(option => {
    const sizeLabel = option.getAttribute('data-size');
    const available = variants.some(v => v.option1 === colorLabel && v.option2 === sizeLabel && v.available);

    option.classList.toggle('unavailable', !available);
    if (available && !firstAvailable) firstAvailable = sizeLabel;
  });

  if (firstAvailable) {
    sizeWrapper.querySelector(SEL.sizeBtn).querySelector('.size-label').textContent = firstAvailable;
    updateVariantId(container);
  } else {
    setAddToCartState(container, false);
  }
}

function updateVariantId(container) {
  if (!container) return;

  const colorLabel = container.querySelector('.color-label')?.textContent;
  const sizeLabel = container.querySelector(SEL.sizeBtn)?.querySelector('.size-label')?.textContent;
  const sizeWrapper = container.querySelector(SEL.sizeWrapper);
  const variantInput = container.querySelector(SEL.variantInput);

  if (!colorLabel || !sizeLabel || !sizeWrapper || !variantInput) return;

  let variants;
  try { variants = JSON.parse(sizeWrapper.getAttribute('data-variants')); }
  catch { return; }

  const variant = variants.find(v => v.option1 === colorLabel && v.option2 === sizeLabel);
  if (!variant) { setAddToCartState(container, false); return; }

  variantInput.value = variant.id;
  setAddToCartState(container, Boolean(variant.available));
  if (!variant.available) return;

  // Yield au navigateur avant de fetcher le prix
  const productHandle = container.querySelector(SEL.colorBtn)?.getAttribute('product-handle');
  if (!productHandle) return;
  setTimeout(() => {
    fetch(`${location.origin}/products/${productHandle}?variant=${variant.id}&section_id=variant_details`)
      .then(r => r.text())
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newPriceList = parsed.querySelector('price-list');
        const priceList = container.querySelector('price-list');

        if (newPriceList && priceList) {
          priceList.replaceWith(newPriceList);
        }
      })
      .catch(err => console.error('[price fetch error]', err));
  }, 0);
}

function placeMenu(btn, menu) {
  const SAFE_BOTTOM_SPACE = 140;
  menu.style.visibility = 'hidden';
  menu.style.display = 'block';
  const btnRect = btn.getBoundingClientRect();
  const menuRect = menu.getBoundingClientRect();
  const cartDrawer = btn.closest('.cart-drawer');
  const footer = cartDrawer?.querySelector('[slot="footer"]');
  const footerTop = footer ? footer.getBoundingClientRect().top : window.innerHeight;
  const drawerTop = cartDrawer ? cartDrawer.getBoundingClientRect().top : 0;
  const spaceBelow = footerTop - btnRect.bottom;
  const spaceAbove = btnRect.top - drawerTop;
  const shouldOpenUp =
    spaceBelow < menuRect.height + 8 || spaceBelow < SAFE_BOTTOM_SPACE;
  if (shouldOpenUp && spaceAbove > 120) {
    menu.style.top = 'auto';
    menu.style.bottom = 'calc(100% + 8px)';
    menu.style.maxHeight = `${Math.max(spaceAbove - 8, 120)}px`;
  } else {
    menu.style.top = 'calc(100% + 8px)';
    menu.style.bottom = 'auto';
    menu.style.maxHeight = `${Math.max(spaceBelow - 8, 120)}px`;
  }
  menu.style.overflowY = 'auto';
  menu.style.visibility = '';
}

// ===== EVENT DELEGATION (single listener) =====
document.addEventListener('click', e => {
  const colorBtn = e.target.closest(SEL.colorBtn);
  if (colorBtn) {
    const menu = colorBtn.closest(SEL.colorWrapper).querySelector(SEL.colorMenu);
    const isOpen = menu.style.display === 'block';
    closeAllMenus();
    if (!isOpen) {
      menu.style.display = 'block';
      placeMenu(colorBtn, menu);
      colorBtn.classList.add('open');
    }
    return;
  }

  const colorOption = e.target.closest(SEL.colorOption);
  if (colorOption) {
    const colorHex = colorOption.getAttribute('data-color');
    const colorLabel = colorOption.querySelector('.color-label').textContent;
    document.querySelectorAll(SEL.colorWrapper).forEach(w => updateProductColor(w, colorHex, colorLabel));
    return;
  }

  const sizeBtn = e.target.closest(SEL.sizeBtn);
  if (sizeBtn) {
    const menu = sizeBtn.closest(SEL.sizeWrapper).querySelector(SEL.sizeMenu);
    const isOpen = menu.style.display === 'block';
    closeAllMenus();
    if (!isOpen) {
      menu.style.display = 'block';
      placeMenu(sizeBtn, menu);
      sizeBtn.classList.add('open');
    }
    return;
  }

  const sizeOption = e.target.closest(`${SEL.sizeOption}:not(.unavailable)`);
  if (sizeOption) {
    const wrapper = sizeOption.closest(SEL.sizeWrapper);
    const sizeBtn = wrapper.querySelector(SEL.sizeBtn);
    sizeBtn.querySelector('.size-label').textContent =
      sizeOption.querySelector('.size-label').textContent;
    wrapper.querySelector(SEL.sizeMenu).style.display = 'none';
    sizeBtn.classList.remove('open');
    updateVariantId(getContainer(wrapper));
    return;
  }

  closeAllMenus();
}, { passive: true });

// ===== INIT =====
function initializeProducts() {
  document.querySelectorAll(`${SEL.recoItem}, ${SEL.hProduct}`).forEach(container => {
    const colorBtn = container.querySelector(SEL.colorBtn);
    const colorLabel = colorBtn?.querySelector('.color-label')?.textContent?.trim();
    const wrapper = colorBtn?.closest(SEL.colorWrapper);
    if (!wrapper || !colorLabel) return;

    updateSizeAvailability(wrapper, colorLabel);
    updateVariantId(container);
  });
}

document.addEventListener('DOMContentLoaded', initializeProducts, { once: true });

// Re-init after cart re-renders the reco items (sticky = synchrone, horizontal = 0ms timeout)
document.addEventListener('cart:change', () => setTimeout(initializeProducts, 100));